import { render, staticRenderFns } from "./testSwiper.vue?vue&type=template&id=2eac39b5&"
import script from "./testSwiper.vue?vue&type=script&lang=js&"
export * from "./testSwiper.vue?vue&type=script&lang=js&"
import style0 from "./testSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/testSwiper.vue
// module id = null
// module chunks = 